import React from 'react';
import moment from 'moment';
import { doctrineAnalytics } from '../../../../utils/analyticsUtils';
import { DayPicker } from './DayPicker';

type Props = {
  accessPremium: boolean;
  openRestrictedModal: Function;
  onDatesUpdate: Function;
  selectedValue?: string;
  type: string;
  formatDate: Function;
};

type State = {
  date?: Date;
};

export class DaySelector extends React.Component<Props, State> {
  state: State = {
    date: this.props.selectedValue
      ? moment(this.props.selectedValue, 'DD/MM/YYYY').toDate()
      : undefined,
  };

  componentDidUpdate(prevProps: Props) {
    if (prevProps.selectedValue !== this.props.selectedValue)
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        date: this.props.selectedValue
          ? moment(this.props.selectedValue, 'DD/MM/YYYY').toDate()
          : undefined,
      });
  }

  submitDatePickerDay = (evt: React.FormEvent<HTMLFormElement>) => {
    const {
      type,
      accessPremium,
      openRestrictedModal,
      onDatesUpdate,
      formatDate,
    } = this.props;
    evt.preventDefault();
    if (!accessPremium) {
      openRestrictedModal('faceted-item');
    } else {
      const { date } = this.state;
      const formatedDay = moment(date).format('DD/MM/YYYY');
      const dateSelector = formatDate(formatedDay);
      doctrineAnalytics('Search DatePickerDayClicked', {
        ...dateSelector,
        search_type: type,
        type: 'custom_day',
      });
      onDatesUpdate(dateSelector);
    }
  };

  onDatePickerChange = (date: Date | Date[]) => {
    if (!Array.isArray(date)) {
      this.setState({
        date,
      });
    }
  };

  render() {
    const { date } = this.state;

    return (
      <DayPicker
        onSubmit={this.submitDatePickerDay}
        onChange={this.onDatePickerChange}
        day={date}
      />
    );
  }
}
